/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const SHIPPING_STEP_COMPONENT_KEY = 'ShippingStepComponent'
